"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _components = require("@folio/stripes/components");
var _NoResultsMessage = _interopRequireDefault(require("../../../styles/NoResultsMessage.css"));
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const NoResultsMessage = _ref => {
  let {
    icon: userIcon,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    isLoading,
    isError,
    error,
    filterPaneIsVisible,
    label: userLabel,
    labelOverrides = {},
    searchTerm,
    toggleFilterPane
  } = _ref;
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  let icon = 'search';
  let label = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
    id: "stripes-smart-components.sas.noResults.default",
    values: {
      searchTerm
    }
  });
  if (!isLoading && !searchTerm) {
    // No search term and not loading
    icon = filterPaneIsVisible ? 'arrow-left' : null;
    label = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
      id: "stripes-smart-components.sas.noResults.noTerms"
    });
  } else if (!isLoading) {
    // Search term but not loading
    icon = 'search';
    label = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
      id: "stripes-smart-components.sas.noResults.noResults"
    });
  } else if (isLoading) {
    // Loading
    icon = 'spinner-ellipsis';
    label = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
      id: "stripes-smart-components.sas.noResults.loading"
    });
  } else if (isError) {
    // Request failure
    icon = 'exclamation-circle';
    label = error?.message;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _NoResultsMessage.default.noResultsMessage,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _NoResultsMessage.default.noResultsMessageLabelWrap,
      children: [(icon || userIcon) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Icon, {
        icon: userIcon ?? icon,
        iconRootClass: _NoResultsMessage.default.noResultsMessageIcon
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _NoResultsMessage.default.noResultsMessageLabel,
        children: userLabel ?? label
      })]
    }), !filterPaneIsVisible && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      buttonClass: _NoResultsMessage.default.noResultsMessageButton,
      marginBottom0: true,
      onClick: toggleFilterPane,
      children: kintIntl.formatKintMessage({
        id: 'showFilters',
        overrideValue: labelOverrides?.showFilters
      })
    })]
  });
};
NoResultsMessage.propTypes = {
  error: _propTypes.default.object,
  filterPaneIsVisible: _propTypes.default.bool.isRequired,
  icon: _propTypes.default.string,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  isLoading: _propTypes.default.bool,
  isError: _propTypes.default.bool,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node, _propTypes.default.func]),
  labelOverrides: _propTypes.default.object,
  searchTerm: _propTypes.default.string,
  toggleFilterPane: _propTypes.default.func.isRequired
};
var _default = exports.default = NoResultsMessage;